//#region src/components/ui/cascader/locale/en_US.ts
var e = { pleaseSelect: "Please select" };
//#endregion
export { e as cascaderLocale };

//# sourceMappingURL=en_US.js.map